import { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const { token, user, isAuthenticated } = useSelector((state) => state.auth);
  const [localUser, setLocalUser] = useState(user);

  useEffect(() => {
    setLocalUser(user);
  }, [user]);

  useEffect(() => {
    if (token) {
      localStorage.setItem("accessToken", token);
    } else {
      localStorage.removeItem("accessToken");
    }
    
    if (user) {
      localStorage.setItem("userData", JSON.stringify(user));
    } else {
      const storedUser = localStorage.getItem("userData");
      if (storedUser) {
        try {
          const parsedUser = JSON.parse(storedUser);
          setLocalUser(parsedUser);
        } catch (e) {
          localStorage.removeItem("userData");
        }
      }
    }
  }, [token, user]);

  const value = {
    isLoggedIn: !!token || !!isAuthenticated,
    userData: localUser || user,
    token: token,
    isAuthenticated: isAuthenticated
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);